import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=0dddf25d&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=0dddf25d&prod&scoped=true&lang=css"
import style1 from "./Student.vue?vue&type=style&index=1&id=0dddf25d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dddf25d",
  null
  
)

export default component.exports